import React, { useState, useEffect } from "react";
import { FaEdit, FaTrash } from "react-icons/fa";

const ClassOverview = ({ selectedClass, onEditClass, onDeleteClass }) => {
  const [students, setStudents] = useState([]);

  useEffect(() => {
    if (selectedClass) {
      const fetchStudents = async () => {
        try {
          const response = await fetch(
            `https://rm.connectifisolutions.com/rosemary_db/getStudentsByClass.php?className=${encodeURIComponent(
              selectedClass.className
            )}`
          );
          const result = await response.json();
          setStudents(result.students);
        } catch (error) {
          console.error("Error fetching students:", error);
        }
      };

      fetchStudents();
    }
  }, [selectedClass]);

  if (!selectedClass) {
    return <div className="class-overview">Select a class to view details</div>;
  }

  return (
    <div className="class-info">
      <div className="header">
        <h3>{selectedClass.className}</h3>
        <div className="stats">{students.length} Students</div>
      </div>

      <div className="actions">
        <button className="edit-btn" onClick={() => onEditClass(selectedClass)}>
          <FaEdit /> Edit Class
        </button>
        <button
          className="delete-btn"
          onClick={() => onDeleteClass(selectedClass)}
        >
          <FaTrash /> Delete Class
        </button>
      </div>

      <div className="students-list">
        <h4>Enrolled Students</h4>
        {students.length > 0 ? (
          students.map((student) => (
            <div key={student.id} className="student-row">
              <span className="name">
                {student.firstName} {student.lastName}
              </span>
              <span className="id">{student.studentId}</span>
            </div>
          ))
        ) : (
          <div className="empty-state">
            <div className="empty-icon">👥</div>
            <div className="empty-text">No Students Enrolled</div>
            <div className="empty-subtext">Add students to this class</div>
          </div>
        )}
      </div>
    </div>
  );
};

export default ClassOverview;
